<template>
  <div class="join-container">
    <div class="join-container_ cen">
      <Breadcrumb>
        <BreadcrumbItem to="/">首页</BreadcrumbItem>
        <BreadcrumbItem to="/join">加入我们</BreadcrumbItem>
        <BreadcrumbItem>{{currentClassName.classname}}</BreadcrumbItem>
      </Breadcrumb>
      <div class="inside-main">
        <div class="volunteer-container">
          <div class="volunteer-detail-item">{{currentClassName.classname}}</div>
          <div class="volunteer-detail-cont" v-html="detailInfo.content"></div>
          <div class="join-form">
            <div class="join-form-head">请填写以下申请信息并提交，以便我们与您取得联系。</div>
            <div class="join-form-container">
              <div class="join-form-container_">
                <div class="join-form-inputbox">
                  <div class="join-form-item"><span>*</span>姓名：</div>
                  <div class="join-form-input"><input type="text" v-model="formdata.name" id="name" class="input" placeholder="填写联系人的姓名"></div>
                </div>
                <div class="join-form-inputbox">
                  <div class="join-form-item"><span>*</span>联系方式：</div>
                  <div class="join-form-input"><input type="text" v-model="formdata.contact" id="contact" class="input" placeholder="填写联系人的联系方式"></div>
                </div>
                <div class="join-form-inputbox">
                  <div class="join-form-item">擅长专业：</div>
                  <div class="join-form-input"><input type="text" v-model="formdata.content" id="profession" class="input" placeholder="请填写"></div>
                </div>
                <div class="join-form-btn" @click="submitForm">确认提交</div>
              </div>
            </div>
          </div>
        </div>
        <div class="inside-left-nav">
          <div class="left-nav-head">
            <div class="chname">{{fname.classname}}</div>
            <div class="enname">{{fname.classname_en}}</div>
          </div>
          <div class="left-nav-list">
            <div class="left-nav-li">
              <router-link to="/join/volunteer" class="left-nav-link">
                <div class="chname">{{getsort[0].classname}}</div>
                <div class="enname">{{getsort[0].classname_en}}</div>
                <span></span>
              </router-link>
            </div>
            <div class="left-nav-li">
              <router-link to="/join/goldenyears" class="left-nav-link">
                <div class="chname">{{getsort[1].classname}}</div>
                <div class="enname">{{getsort[1].classname_en}}</div>
                <span></span>
              </router-link>
            </div>
            <div class="left-nav-li active">
              <router-link to="/join/socialservice" class="left-nav-link">
                <div class="chname">{{getsort[2].classname}}</div>
                <div class="enname">{{getsort[2].classname_en}}</div>
                <span></span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { validateContact } from '../../assets/js/validate.js'
import { getHeaderData, getJoinBasicData, getJoinDetailData, postJoinMessage } from '../../api/getData.js'
export default {
  name: 'socialService',
  data () {
    return {
      headerInfo: {},
      cid: 24,
      currentClassName: '',
      fname: {},
      getsort: [],
      detailInfo: [],
      loading: false,
      formdata: {
        name: '',
        contact: '',
        content: '',
        status: 's'
      }
    }
  },
  metaInfo () {
    return {
      title: this.headerInfo.title,
      meta: [
        { name: 'generator', content: this.headerInfo.generator },
        { name: 'author', content: this.headerInfo.author },
        { name: 'keywords', content: this.headerInfo.keywords },
        { name: 'description', content: this.headerInfo.description }
      ]
    }
  },
  created () {
    this.getJoinBasicInfo(this.cid)
  },
  methods: {
    async getHeaderInfo () {
      let postData = { cid: this.cid }
      let header = await getHeaderData(postData)
      this.headerInfo = header.header
      this.$store.dispatch('SetActiveMenu', { activeMenu: 'join', activeSendMenu: 'socialservice' }).then(() => {}).catch(() => {})
    },
    async getJoinBasicInfo (cid) {
      let postData = {}
      postData.cid = cid
      let result = await getJoinBasicData(postData)
      this.cid = result.cid
      this.currentClassName = result.cname
      this.fname = result.fname
      this.getsort = result.join_us
      this.getHeaderInfo()
      this.getJoinInfo()
    },
    async getJoinInfo () {
      let postData = {}
      postData.cid = this.cid
      let result = await getJoinDetailData(postData)
      this.detailInfo = result.info
    },
    async submitForm () {
      if (this.formdata.name === '') {
        this.message('请输入姓名')
        return false
      }
      if (this.formdata.contact === '') {
        this.message('请输入联系方式')
        return false
      }
      if (!validateContact(this.formdata.contact)) {
        this.message('联系方式格式不正确')
        return false
      }
      if (this.loading) {
        return false
      }
      this.loading = true
      let result = await postJoinMessage(this.formdata)
      if (result.code === '1') {
        this.message('提交成功')
        this.loading = false
      } else {
        this.message('提交失败')
        this.loading = false
      }
    },
    message (content) {
      this.$alert(content, '提示', {
        confirmButtonText: '确定',
        callback: action => {}
      })
    }
  }
}
</script>

<style scoped lang="less">
  .join-container_{
    padding-bottom: 60px;
  }
  .volunteer-container{
    width: 77.22%;
    padding: 0 62px 78px;
    background-color: #ffffff;
    box-shadow: 0px 0px 13px 0px rgba(37, 37, 37, 0.15);
    border-radius: 5px;
    .volunteer-detail-item{
      border-left: 4px solid #e76321;
      margin-top: 72px;
      padding-left: 20px;
      font-size: 36px;
      line-height: 36px;
      color: #ec6420;
      font-weight: bold;
    }
    .volunteer-detail-cont{
      margin-top: 40px;
      font-size: 24px;
      line-height: 40px;
      text-align: justify;
      color: #333333;
    }
    .join-form{
      width: 900px;
      margin: 68px auto 0;
      .join-form-head{
        font-size: 36px;
        line-height: 42px;
        text-align: center;
        color: #4b7bbe;
      }
      .join-form-container{
        margin-top: 50px;
        padding: 0 20px;
        .join-form-container_{
          padding: 340px 0 60px;
          border-radius: 12px;
          background-color: #ffffff;
          background-image: url("../../assets/images/join-form-bg.png");
          background-position: center top;
          background-repeat: no-repeat;
          box-shadow: 0px 0px 18px 0px rgba(37, 37, 37, 0.14);
          overflow: hidden;
          .join-form-inputbox{
            overflow: hidden;
            .join-form-item{
              float: left;
              width: 200px;
              font-size: 24px;
              line-height: 90px;
              text-align: right;
              color: #333333;
              span{
                margin-right: 10px;
                color: #ff6666;
              }
            }
            .join-form-input{
              width: 66.28%;
              height: 90px;
              padding: 15px 20px;
              border-radius: 30px;
              overflow: hidden;
              .input{
                outline: none;
                border: none;
                width: 100%;
                height: 60px;
                padding: 0 40px;
                border-radius: 30px;
                box-shadow: 0px 0px 18px 0px rgba(37, 37, 37, 0.15);
                font-size: 16px;
                color: #666666;
              }
            }
          }
          .join-form-btn{
            width: 430px;
            height: 70px;
            margin: 25px auto 0;
            border-radius: 35px;
            background-color: #4b7bbe;
            font-size: 30px;
            line-height: 70px;
            text-align: center;
            color: #ffffff;
            cursor: pointer;
          }
        }
      }
    }
  }
  @media screen and (max-width: 1400px){
    .volunteer-container{
      .join-form{
        width: 100%;
        .join-form-head{
          font-size: 28px;
        }
      }
    }
  }
  @media screen and (max-width: 1200px){
    .volunteer-container{
      width: 100%;
      margin-bottom: 20px;
      padding: 36px 15px 39px;
      border-radius: 2px;
      .volunteer-detail-item{
        border-left: 2px solid #e76321;
        margin-top: 0;
        padding-left: 10px;
        font-size: 18px;
        line-height: 18px;
      }
      .volunteer-detail-cont{
        margin-top: 20px;
        font-size: 12px;
        line-height: 20px;
      }
      .join-form{
        width: auto;
        margin: 34px auto 0;
        .join-form-head{
          font-size: 18px;
          line-height: 21px;
        }
        .join-form-container{
          margin-top: 25px;
          padding: 0;
          .join-form-container_{
            padding: 120px 20px 30px;
            border-radius: 6px;
            background-size: 100% auto;
            .join-form-inputbox{
              overflow: hidden;
              .join-form-item{
                float: none;
                width: 100%;
                font-size: 16px;
                line-height: 45px;
                text-align: left;
                span{
                  margin-right: 5px;
                }
              }
              .join-form-input{
                width: 100%;
                height: 45px;
                padding: 7px 10px;
                border-radius: 22px;
                .input{
                  width: 100%;
                  height: 30px;
                  padding: 0 20px;
                  border-radius: 30px;
                  font-size: 12px;
                }
              }
            }
            .join-form-btn{
              width: 100%;
              height: 35px;
              margin: 20px auto 0;
              border-radius: 17px;
              font-size: 15px;
              line-height: 35px;
            }
          }
        }
      }
    }
  }
</style>
<style lang="less">
  .volunteer-detail-cont{
    img,iframe,video{
      max-width: 100%;
    }
  }
</style>
